import { createContext, useCallback, useContext, useState } from "react";
import { ShareCard } from "./ShareCard";

const ShareCtx = createContext(() => {});
export const useShare = () => useContext(ShareCtx);

// Mounts a single ShareCard modal and exposes openShare(deal) app-wide so any
// surface (settled tape, escrow ticket, settlement toast/alert) opens the same card.
export function ShareProvider({ children }) {
  const [deal, setDeal] = useState(null);
  const openShare = useCallback((d) => setDeal(d), []);
  return (
    <ShareCtx.Provider value={openShare}>
      {children}
      <ShareCard deal={deal} onClose={() => setDeal(null)} />
    </ShareCtx.Provider>
  );
}
